import MemberMixin from 'trunks/vue/share/components/fields/member.js';
import UserItem from 'trunks/vue/admin/components/libs/user_item.js';
import FieldMixinForResponse from './mixin.js';
import PopoverGroupOptionsSelect from 'trunks/vue/share/components/popover_group_options_select.js';

const MemberForResponse = {
  mixins: [
    FieldMixinForResponse,
    MemberMixin
  ],

  components: {
    'popove-option-select': PopoverGroupOptionsSelect,
    'user-item': UserItem
  },

  template: `
    <Field :field='field'
           v-show='visible'
           :extendClass='[fieldCommonClass, fieldDifferenceClass]'
           :message='errorMsg'>
      <template slot='input'>
        <div class="vertical-middle" v-if='value'>
          <user-item :user='value'
                     size='small'
                     :removable='editing'
                     @removed='destroyValue' />
        </div>
        <popove-option-select v-else-if='editing && !value'
                       extendClass='member-select'
                       remote='/admin/users/query'
                       :initialSelectedOptions='initValue'
                       @submitClicked='update'>
          <template slot='trigger'>
            <button class='btn-default'>
              <span>添加人员</span>
              <i class="slp-search"></i>
            </button>
          </template>
          <template slot='option-item-template' slot-scope='{ option }'>
            <div class='content'>
              <div class='user-item small'>
                <headimg :src='option.headimgurl' extendClass='member-headimg' />
                <span class='name'>{{ option.name }}</span>
                <span class="gray-text">{{ option.identifier }}</span>
              </div>
            </div>
            <i class='tip' :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
          </template>
          <div slot='filter-blankslate' class="list-group-name">没有相关人员</div>
          <div slot='options-blankslate' class="list-group-name">没有相关人员</div>
        </popove-option-select>
        <div class="form-field-value readonly placeholder" v-else>未填写</div>
      </template>
    </Field>
  `,

  computed: {
    initValue: function() {
      if (this.value) {
        return [this.value];
      } else {
        return [];
      }
    }
  },

  methods: {
    update: function(newValue) {
      this.valueChange(newValue[0] || null);
    }
  }
};

export default MemberForResponse;
